<script>
  import { domainName, recordCreated } from '../stores.js';
  import DMARCInstructions from './dmarcInstructions.svelte';
  import DMARCNewRecord from './dmarcNewRecord.svelte';
  // import DMARCShare from './dmarcShare.svelte';
  import Sidebar from '../Sidebar.svelte';
</script>

<section class="tool-banner tool-banner-dmarc mb-5">
  <div class="banner"></div>
  <div class="row-wrapper">
    <div class="container">
      <div class="row">
        <div class="col-12 m-auto banner-text">
          <h1>View New DMARC Record</h1>
          <p>Prevent unauthorized email using your domain from being delivered.</p>
          <button on:click={() => window.location.reload()} class ="refresh-page" title="Look Up or Generate DMARC Record">Search New Domain</button><i class="fa-solid fa-arrows-rotate"></i>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-8 m-auto">
          <div class="result-box">
            <div class="found">
              <ul class="result-heading">
                {#if recordCreated.dmarc_records == null && recordCreated.errors }
                  <li><h3>{recordCreated.errors}</h3></li>
                {:else}
                  <li><h3>Your DMARC record for {$domainName} has been created. To publish it to your DNS, please follow the instructions below.</h3></li>
                {/if}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

<section class="record record-dmarc">
  <div class="container">
    <div class="row">
      <div class="col-lg-8">
        <DMARCInstructions />
        <DMARCNewRecord />
      </div>

      <div class="col-lg-4">
        <!-- <DMARCShare /> -->
        <Sidebar />
      </div>
    </div>
  </div>
</section>

<style>

</style>
